var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-8 bg-white flex-grow self-stretch sm:flex-grow-0 sm:self-center sm:rounded-md sm:shadow sm:-mt-14"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }